// Import Packages
import React from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import { Dialog, DialogContent, CircularProgress } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const SimulateModal = ({ checkSimulatePendingMessage }) => {
    const { t } = useTranslation();

    return (
        <Dialog maxWidth="xs" open>
            <DialogContent >
                {checkSimulatePendingMessage ? t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.SCOPE.SCOPE-RE-TAKE-IN-PROGRESS') : t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.SCOPE.SIMULATE-IN-PROGRESS')}
                <div className="items-center-center mt10">
                    <CircularProgress />
                </div>

            </DialogContent>
        </Dialog>
    )
}

export default SimulateModal;